var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 590.12 369.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.61,369.32L0,184.66,132.61,0l14.46,46.17L45.85,184.66l101.22,138.5-14.46,46.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.38,335.77V40.31h25.8v103.01c6.93-6.11,14.73-9.16,23.38-9.16,9.98,0,19.17,3.37,27.59,10.08,8.41,6.72,15.16,17.32,20.24,31.8,5.08,14.47,7.62,33.51,7.62,57.09s-2.54,42.77-7.62,57.92c-5.09,15.15-11.84,26.39-20.24,33.72-8.42,7.33-17.61,11-27.59,11-10.93,0-20.29-4.64-28.08-13.93l-6.99,13.93h-14.11ZM223.86,164.94c-8.75,0-15.97,4.22-21.67,12.65v114.74c5.7,8.43,12.92,12.65,21.67,12.65,5.32,0,10.31-2.2,14.97-6.6,4.65-4.4,8.46-11.83,11.4-22.27,2.94-10.45,4.42-24.77,4.42-42.98s-1.48-32.23-4.42-42.06c-2.95-9.84-6.75-16.65-11.4-20.44-4.66-3.78-9.65-5.68-14.97-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.76,335.58l-46.47-203.45h27.51l17.96,84.68,6.13,38.12,13.4-38.12,17.39-51.69h.29l19.39,51.69,12.26,38.12,4.99-37.76,17.96-85.05h27.51l-46.47,203.63h-.43l-19.25-59.57-15.82-41.61h-.29l-14.26,41.42-21.38,59.57h-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.51,369.32l-16.76-46.17,101.22-138.5-101.22-138.5L457.51,0l132.61,184.66-132.61,184.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.07e49570358cbd3124d8e9e1ac636481.svg";
export { ForwardRef as ReactComponent };